
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pipelines",
      function () {
        return require("private-next-pages/pipelines/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pipelines"])
      });
    }
  